import { lazy } from "react";
// import { Navigate } from "react-router-dom";

const Location = lazy(() => import("./locationPage"));
const Report = lazy(() => import("./reportPage"));
const Summary = lazy(() => import("./summaryPage"));
const Setting = lazy(() => import("./settingPage"));
const PageNotFound = lazy(() => import("./pageNotFound"));

const PagesConfig = [{
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "location",
      element: <Location />,
    },
    {
      path: "report",
      element: <Report />,
    },
    {
      path: "summary",
      element: <Summary />,
    },
    {
      path: "setting",
      element: <Setting />,
    },
    {
      path: "pagenotfound",
      element: <PageNotFound />,
    },
    {
      path: "api/",
      element: <PageNotFound />,
    },
    {
      path: "api/*",
      element: <PageNotFound />,
    },
  ],
}];

export default PagesConfig;
